import React from "react";
import { m } from "framer-motion";

const FAQ = ({ faq }) => (
  <m.section style={{ contentVisibility: "auto", containIntrinsicSize: "0 600px" }}>
    <div className='bg-white'>
      <div className='px-6 py-12 mx-auto max-w-7xl divide-y divide-gray-900/10 md:py-32 xxxl:px-8 xxxl:py-40 sm:px-12'>
        <h1 className='text-2xl font-bold leading-10 tracking-tight !text-inaqgold font-["Oxanium"]'>
          {faq.headline}
        </h1>
        <dl className='mt-10 space-y-8 divide-y divide-gray-900/10 pointer-events-none'>
          {faq.items.map((item) => (
            <div
              key={item.id}
              className='pt-8 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 xxxl:grid-cols-12 xxxl:gap-8 md:gap-4'
            >
              <dt className='text-base font-semibold leading-12 text-gray-900 mb-2 md:mb-0 xxxl:mb-0 xxxl:col-span-5 stdc-title'>
                {item.question}
              </dt>
              <dd className='mt-0 xxxl:col-span-7 xxxl:mt-0 '>
                {Array.isArray(item.answer) ? (
                  item.answer.map((p, idx) => (
                    <p
                      key={idx}
                      className={`text-base  text-gray-600 ${idx > 0 ? "mt-4" : ""}`}
                    >
                      {p}
                    </p>
                  ))
                ) : (
                  <p className='text-base  text-gray-600'>{item.answer}</p>
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </m.section>
);

export default FAQ;
